export class OAuthClientDetail {
  clientId: string;
  userId: string;
  resourceIds: string;
  secretRequired: boolean;
  clientSecret: string;
  scoped: boolean;
  scope: string;
  authorizedGrantTypes: string;
  registeredRedirectUri: string;
  authorities: string;
  accessTokenValiditySeconds: number;
  refreshTokenValiditySeconds: number;
  autoApprove: boolean;
  clientName: string;
  clientEmail: string;
  createdAt: any;
  updatedAt: any;

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/d90c5bcf/0/gaia/gaia-ui-angular/src/app/client/oauth-client-detail.ts